export default __webpack_public_path__ + "static/media/arrow-down.897f129b.svg";